module.exports = __webpack_public_path__ + "static/media/SettingsNew.e631e7d2.svg";